export const API_SEARCH_MOVIE = '1B'
export const API_SEARCH_MOVIE_SUCCESS = '1B1'